import { render, staticRenderFns } from "./online_work.vue?vue&type=template&id=a5c1ec88&scoped=true"
import script from "./online_work.vue?vue&type=script&lang=js"
export * from "./online_work.vue?vue&type=script&lang=js"
import style0 from "./online_work.vue?vue&type=style&index=0&id=a5c1ec88&prod&scoped=true&lang=less"
import style1 from "./online_work.vue?vue&type=style&index=1&id=a5c1ec88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c1ec88",
  null
  
)

export default component.exports